import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'react-bootstrap';

const EmptyTableAlert = ({ numberOfColumns, message }) => (
  <tbody>
    <tr>
      <td colSpan={numberOfColumns}>
        <Alert variant="warning">{message}</Alert>
      </td>
    </tr>
  </tbody>
);

EmptyTableAlert.propTypes = {
  numberOfColumns: PropTypes.number.isRequired,
  message: PropTypes.string.isRequired
};

export default EmptyTableAlert;
